export default "__VITE_ASSET__H7j$zM9y__"